"use client";
import React, { useState, useEffect } from "react";
import Loader from "../Loader/Loader";
import ImageGallery from "react-image-grid-gallery";
import "./Autografika.css";
import Navbar from "../Navbar/Navbar";
import LijeviMeni from "../Pocetna/LijeviMeni";
import Footer from "../Pocetna/Footer/Footer";

import "./stirodur.css";

const importAll = (r) => r.keys().map(r);
const stirodurNatpisiImages = importAll(
  require.context("../../assets/grafikaZastava", false, /\.(webp)$/i)
);

const Zastave = () => {
  const [isContentLoaded, setIsContentLoaded] = useState(false);
  const [buttonText, setButtonText] = useState("Pročitaj više");

  useEffect(() => {
    const fakeApiCall = setTimeout(() => {
      setIsContentLoaded(true);
    }, 1000);

    return () => clearTimeout(fakeApiCall);
  }, []);

  const imagesArray = stirodurNatpisiImages.map((image, index) => ({
    alt: `Image${index + 1}'s alt text`,
    src: image,
  }));

  const [isParagraphVisible, setIsParagraphVisible] = useState(false);

  const handleButtonClick = () => {
    setIsParagraphVisible(!isParagraphVisible);
    setButtonText(
      isParagraphVisible ? "Pročitaj više" : "Zatvori dodatni tekst"
    );
  };

  return (
    <div>
      {!isContentLoaded ? (
        <Loader />
      ) : (
        <>
          <Navbar />
          <div className="autografika-main">
            <div className="container">
              <div className="row reverse" id="usluge-navi">
                {/* Left column for */}
                <LijeviMeni />
                {/* Right column for */}
                <div className="col-md-8 bg">
                  <h1>Zastave</h1>{" "}
                  <div className="autografika-opis">
                    <p>
                      Digni svoj brend na viši nivo s našim personalizovanim
                      zastavama koje ističu tvoj identitet i privlače pažnju. U
                      našoj štampariji, pravimo zastave koje su više od običnih
                      komada platna - one su simbolički izraz tvoje vizije i
                      vrijednosti.
                    </p>
                    <div className="vise-button">
                      <button
                        type="button"
                        className="btn btn-dark"
                        onClick={handleButtonClick}
                      >
                        {buttonText}
                      </button>
                    </div>

                    {isParagraphVisible && (
                      <>
                        <p>
                          Bilo da želiš zastavu za svoju kompaniju, sportski
                          događaj, političku kampanju ili poseban događaj, naš
                          tim stručnjaka garantuje vrhunsku izradu i
                          visokokvalitetnu štampu. Naša paleta materijala i
                          tehnika omogućava ti da izraziš svoju kreativnost na
                          najbolji mogući način.
                        </p>
                        <p>
                          S ponosom stvaramo zastave koje traju, bilo da se
                          koriste unutar prostora ili vise napolju, ističući se
                          svojom izdržljivošću i vibrantnim bojama. Odluči se za
                          vrhunski kvalitet i pouzdanost s našim uslugama izrade
                          zastava - tvoj simbol zaslužuje najbolje!
                        </p>
                      </>
                    )}
                  </div>
                  <div className="stirodur-grid">
                    <ImageGallery
                      imgArray={imagesArray}
                      columnWidth={230}
                      gapSize={4}
                    />
                  </div>
                  <div className="stirodur-grid-mobile">
                    <ImageGallery
                      imgArray={imagesArray}
                      columnWidth={230}
                      gapSize={4}
                    />
                  </div>
                  <div className="display-text-mobile">
                    <p>
                      Bilo da želiš zastavu za svoju kompaniju, sportski
                      događaj, političku kampanju ili poseban događaj, naš tim
                      stručnjaka garantuje vrhunsku izradu i visokokvalitetnu
                      štampu. Naša paleta materijala i tehnika omogućava ti da
                      izraziš svoju kreativnost na najbolji mogući način.
                    </p>
                    <p>
                      S ponosom stvaramo zastave koje traju, bilo da se koriste
                      unutar prostora ili vise napolju, ističući se svojom
                      izdržljivošću i vibrantnim bojama. Odluči se za vrhunski
                      kvalitet i pouzdanost s našim uslugama izrade zastava -
                      tvoj simbol zaslužuje najbolje!
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <Footer />
          </div>
        </>
      )}
    </div>
  );
};

export default Zastave;
